module.exports = __webpack_public_path__ + "img/backHome_07.7cf8d033.png";